import React from 'react'
import History from '../../Components/History'
import { MOCK_USER_HISTORY } from '../../mock'
import styles from '../../../CSS/main.css'
import { ButtonActive } from '../../Components/Button/Button'
import { useNavigation } from '../../utils/navigation'
import Page from '../../Components/Page'
import { PortalType, SlotPortal } from '../../Components/Portal'
import Breadcrumbs from '../../Components/Breadcrumbs'
import Box from '../../Components/Box'
import { useListHistoryState } from './CommentHistory'

const CommentHistory: React.VFC = () => {
  const { goBack } = useNavigation()
  const {
    commentHistories
  } = useListHistoryState()

  return (
    <Page isInfoPage>
      <SlotPortal name={PortalType.Toolbar}>
        <Breadcrumbs onBack={goBack} title={'Comment History'} />
      </SlotPortal>
      <Box>
        <History items={commentHistories}>
          <div className={styles.ButtonBlock}>
            <ButtonActive onClick={goBack}>Return to Comment</ButtonActive>
          </div>
        </History>
      </Box>
    </Page>
  )
}

export default CommentHistory
